import { StagingTitelineAppDDRRejectLog } from "../types/StagingTitelineAppDDRRejectLog";
import { getApiUrl } from '../config/api';

export const addRejectLog = async (log: StagingTitelineAppDDRRejectLog): Promise<boolean> => {

    console.log('StagingTitelineAppDDRRejectLog', log);

    try {
        const response = await fetch(getApiUrl('/api/TitelineDDRRejectLog'), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(log),
        });

        if (response.ok) {
            console.log("Rejection log added to cloud successfully.");
            return true;
        } else {
            console.error("Failed to add rejection log to cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in addRejectLog API call:", error);
        return false;
    }
};

export const fetchLatestLogMessageByPid = async (
    pid: number = -1,
    aid: number = 0
): Promise<string> => {
    const url = getApiUrl(`/api/TitelineDDRRejectLog/by-pid-and-aid/${pid}/${aid}`);

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No reject log found for Pid: ${pid} (404 Not Found)`);
            } else {
                console.error(`Error fetching latest log for Pid ${pid}:`, response.status, response.statusText);
            }
            return "Reviewer left no feedback :(";
        }

        const log: StagingTitelineAppDDRRejectLog = await response.json();

        const message = log?.Message?.trim();
        return message && message.length > 0 ? message : "Reviewer left no feedback :(";

    } catch (error) {
        console.error("Error in fetchLatestLogMessageByPid API call:", error);
        return "Reviewer left no feedback :(";
    }
};